import React from 'react';
import { Outlet } from 'react-router-dom';
import { Box } from '@mui/material';

export default function OnboardingLayout(){
  return (
    <Box sx={{ minHeight: '100vh', bgcolor: '#f9f9f9' }}>
      {/* You can customize the header or other UI elements specific to onboarding */}
      <Outlet /> {/* This will render the specific pages inside the layout */}
    </Box>
  );
};

